import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { isContactUsActive } from "../../functions";
import MenuList from "./MenuList";
import BurgerMenu from "./BurgerMenu";
import { flatListToHierarchical } from "./utils";
import { EnvelopeIcon } from "@heroicons/react/24/outline";

const HeaderInner = ({ post, isHomePage, headerEl, isFixed, headerAppear }) => {
  const {
    allWpMenuItem: { nodes },
    wp: {
      customisationGNRale: {
        acfCustomisation: { logo },
      },
    },
  } = useStaticQuery(graphql`
    query getMenuPrincipalItems {
      allWpMenuItem(
        filter: { menu: { node: { slug: { in: "menu-principal" } } } }
      ) {
        nodes {
          id
          label
          url
          parent: parentId
        }
      }
      wp {
        customisationGNRale {
          acfCustomisation {
            logo {
              fieldGroupName
              noir {
                altText
                localFile {
                  childImageSharp {
                    fixed(width: 165, jpegQuality: 10) {
                      src
                    }
                  }
                  publicURL
                }
              }
              blanc {
                altText
                localFile {
                  childImageSharp {
                    fixed(width: 165, jpegQuality: 10) {
                      src
                    }
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `);

  const hierarchicalList = flatListToHierarchical(nodes);

  return (
    <header
      className={
        "menu-principal " +
        `${isFixed ? "fixed " : ""}` +
        `${headerAppear ? "appear" : ""}`
      }
      ref={headerEl}
    >
      <div className="inner">
        <div className="block-left">
          <h1>
            <Link to="/">
              {logo ? (
                <img
                  src={
                    logo.noir.localFile.childImageSharp?.fixed?.src ||
                    logo.noir.localFile.publicURL
                  }
                  alt={logo.noir.altText}
                />
              ) : null}
            </Link>
          </h1>
          <nav>
            <ul className="first-level">
              {nodes && <MenuList nodes={hierarchicalList} />}
            </ul>
          </nav>
        </div>
        <div className="block-right">
          {!isContactUsActive(post) ? (
            <Link className="call-to-action" to="/contactez-nous">
              <EnvelopeIcon
                style={{
                  width: "18px",
                  transition: "opacity 0.3s ease",
                  marginRight: "8px",
                }}
              />
              Nous contacter
            </Link>
          ) : null}
          <BurgerMenu nodes={hierarchicalList} post={post} />
        </div>
      </div>
    </header>
  );
};

export default HeaderInner;
